














import { Component, Vue } from 'vue-property-decorator';
import NavBar from '@/components/layout/NavBar.vue';
import NavBarNavigation from '@/components/layout/NavBarNavigation.vue';

import { NavigationSection } from '@/types/types';

@Component({
  components: {
    NavBar,
    NavBarNavigation
  }
})
export default class Main extends Vue {
  private readonly navigationSections: NavigationSection[] = [
    {
      i18nKey: 'bills.navbar.list',
      name: 'billsList'
    },
    {
      i18nKey: 'bills.navbar.new',
      name: 'billNew'
    }
  ];
}
